import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.string.replace.js";
var nameWithAbPrefix = function nameWithAbPrefix(testName) {
  return "ab-test-".concat(testName);
};

/**
 * AB test helper
 * Name template: <testName>-<date>
 * Cookie name: ab-test-<testName>-<date>
 */
export default (function (ctx, inject) {
  function init(testName) {
    var days = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 90;
    var forceBranch = arguments.length > 2 ? arguments[2] : undefined;
    var cookieName = nameWithAbPrefix(testName);
    var abTestBranch = ctx.$cookies.get(cookieName);
    if (!abTestBranch || forceBranch) {
      abTestBranch = forceBranch || (Math.random() > 0.5 ? 'a' : 'b');
      ctx.$cookies.set(cookieName, abTestBranch, {
        maxAge: 60 * 60 * 24 * days
      });
    }
    return abTestBranch;
  }
  function getTestBranch(testName) {
    return ctx.$cookies.get(nameWithAbPrefix(testName));
  }
  function getAll() {
    var abTests = {};
    var cookiesKeys = Object.keys(ctx.$cookies.getAll());
    cookiesKeys.forEach(function (cookie) {
      if (cookie.match(/ab-test-/)) {
        abTests[cookie.replace(/ab-test-/, '')] = ctx.$cookies.get(cookie);
      }
    });
    return abTests;
  }
  function saveToServer(name, branch) {
    if (!ctx.$auth.loggedIn || !name) return;
    ctx.$api.$put('/users/current/add_ab_test.json', {
      ab_test: {
        name: nameWithAbPrefix(name),
        branch: branch
      }
    });
  }
  inject('ab', {
    init: init,
    getTestBranch: getTestBranch,
    getAll: getAll,
    saveToServer: saveToServer
  });
});